import { createContext, useContext, useEffect } from 'react';

import type { FloatingResourceAddContext } from './types';

const defaultContextValue: FloatingResourceAddContext = {
    setVisible: () => {
        throw new Error('FloatingResourceAddProvider not found');
    },
    visible: true
};

export const context = createContext<FloatingResourceAddContext>(defaultContextValue);

export const useFloatingResourceAddContext = (visible?: boolean) => {
    const { setVisible, visible: currentVisible } = useContext(context);

    useEffect(() => {
        if (visible !== undefined) {
            setVisible(visible);

            return () => {
                setVisible(true);
            };
        }
    }, [setVisible, visible]);

    return {
        context,
        setVisible,
        visible: currentVisible
    };
};
